import { render, staticRenderFns } from "./PrivacyPolicyMobileView.vue?vue&type=template&id=494b2d91&scoped=true&"
import script from "./PrivacyPolicyMobileView.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b2d91",
  null
  
)

export default component.exports